export enum PickleballOrder {
    ODD = "ODD",
    EVEN = "EVEN"
}